const CURRENCY_SYMBOLS = {
  ZAR: 'R',
  USD: '$',
  GBP: '£',
  EUR: '€',
  BWP: 'P',
  ZMW: 'ZK',
  MWK: 'MK',
  KES: 'KSh',
  NGN: '₦',
  ZWG: 'ZiG',
}

/**
 * Format a monetary amount with the appropriate currency symbol.
 * @param {number} amount
 * @param {string} [currency] - ISO currency code
 * @returns {string} e.g. "R150.00" or "$7.14"
 */
export function formatMoney(amount, currency = 'ZAR') {
  const num = Number(amount || 0)
  const symbol = CURRENCY_SYMBOLS[currency?.toUpperCase()] || currency || ''
  return `${symbol}${num.toFixed(2)}`
}

/**
 * Format a price range.
 * @param {number|number[]} range
 * @param {string} [currency]
 * @returns {string} e.g. "R10.00 – R50.00"
 */
export function formatPriceRange(range, currency = 'ZAR') {
  if (Array.isArray(range) && range.length === 2) {
    return `${formatMoney(range[0], currency)} – ${formatMoney(range[1], currency)}`
  }
  return formatMoney(range, currency)
}

export { CURRENCY_SYMBOLS }
